const initialState = {
  map: {},
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case "USERS_FETCH_SUCCESS": {
      const map = {};

      action.payload.data.users.forEach(function (user) {
        map[user.id] = user;
      });

      return {
        ...state,
        map,
      };
    }
    case "USER_UPDATE_SUCCESS":
    case "USER_BD_REP_CODE_UPDATE_SUCCESS": {
      const newMap = Object.assign({}, state.map);
      newMap[action.payload.user.id] = action.payload.user;
      return {
        ...state,
        map: newMap,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.reducer.js